import React, { Component, useEffect, useState } from 'react';
import { Form, Col } from 'react-bootstrap';
import Stepper from './Stepper';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import Select from 'react-select';
import { api_url, headers, cors_api_url } from '../../common/config';
import { useDropzone } from 'react-dropzone';
import upload from '../../assets/images/icons/ic-upload.svg';
import axios from 'axios';
import filesize from 'filesize';
import { withTranslation, useTranslation } from 'react-i18next';
import i18next from 'i18next';
import {
    colourStyles,
    dangerStyles,
    majorOptns,
    en_majorOptns,
} from './Options';

const name = /^[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z ]+[\u0600-\u065F\u066A-\u06EF\u06FA-\u06FFa-zA-Z-_ ]*$/;
const mobile = /(^(\+\d{1,3}[- ]?)?\d{10}$)|(^(\+[\u0660-\u0669]{1,3}[- ]?)?[\u0660-\u0669]{10}$)/;
const emailCheck = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

const thumbsContainer = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    width: '100%',
};

const thumb = {
    display: 'inline-flex',
    borderRadius: 2,
    border: '1px solid #eaeaea',
    marginBottom: 8,
    marginRight: 8,
    width: '50%',
    height: 'auto',
    padding: 4,
    boxSizing: 'border-box',
    alignItems: 'center',
    justifyContent: 'center',
};

const thumbInner = {
    display: 'flex',
    minWidth: 'inherit',
    overflow: 'hidden',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'visible',
};

function Previews(props) {
    const [files, setFiles] = useState([]);
    const { getRootProps, getInputProps } = useDropzone({
        accept: 'image/*,.pdf,.doc,.docx',
        onDrop: (acceptedFiles) => {
            props.onFile(acceptedFiles);
            setFiles(
                acceptedFiles.map((file) =>
                    Object.assign(file, {
                        preview: URL.createObjectURL(file),
                    })
                )
            );
        },
    });

    const thumbs = files.map((file) => (
        <div style={thumb} key={file.name}>
            <div style={thumbInner}>
                {/* {console.log(file)} */}
                <p style={{ color: '#676767' }}>{file.name}</p>
                <p style={{ color: '#676767' }}>
                    {filesize(file.size, { base: 10 })}
                </p>
            </div>
        </div>
    ));

    useEffect(
        () => () => {
            // Make sure to revoke the data uris to avoid memory leaks
            files.forEach((file) => URL.revokeObjectURL(file.preview));

            // console.log(props);
        },
        [files]
    );

    const { t } = useTranslation();
    return (
        <section className='container dnd'>
            <div {...getRootProps({ className: 'dropzone' })}>
                <img src={upload} />
                <input {...getInputProps()} />
                <p className='dnd-text'>
                    {t('register.job.formLabels.upload.1')}
                    <span
                        style={{
                            color: '#7670ff',
                            margin: '0 0.5em',
                            cursor: 'pointer',
                        }}
                    >
                        {t('register.job.formLabels.upload.2')}
                    </span>
                    {t('register.job.formLabels.upload.3')}
                </p>
            </div>
            <aside style={thumbsContainer}>{thumbs}</aside>
        </section>
    );
}

const Input = ({ type, name, label, value, onChange, empty }) => {
    return (
        <>
            <div
                className={`${
                    i18next.language === 'ar'
                        ? 'tb-container'
                        : 'tb-container text-left ml-0'
                }`}
            >
                <input
                    className={`aumd-tb ${empty === true ? 'aumd-tb-d' : ''}`}
                    id={name}
                    name={name}
                    type={type}
                    placeholder=' '
                    value={value}
                    onChange={onChange}
                />
                <label
                    className={`${
                        i18next.language === 'ar'
                            ? 'aumd-tb-label'
                            : 'en-aumd-tb-label'
                    }`}
                    for={name}
                >
                    {label}
                </label>
                <span
                    className={`validation ${empty === true ? 'vd' : ''}`}
                ></span>
            </div>
        </>
    );
};

const InvalidInput = ({ type, name, label, value, onChange, empty }) => {
    return (
        <>
            <div
                className={`${
                    i18next.language === 'ar'
                        ? 'tb-container'
                        : 'tb-container text-left ml-0'
                }`}
            >
                <input
                    className={`aumd-tb-invalid ${
                        empty === true ? 'aumd-tb-d' : ''
                    }`}
                    id={name}
                    name={name}
                    type={type}
                    placeholder=' '
                    value={value}
                    onChange={onChange}
                />
                <label
                    className={`${
                        i18next.language === 'ar'
                            ? 'aumd-tb-label-invalid'
                            : 'en-aumd-tb-label-invalid'
                    }`}
                    for={name}
                >
                    {label}
                </label>
                <span
                    className={`validation ${empty === true ? 'vd' : ''}`}
                ></span>
            </div>
        </>
    );
};

class Job extends Component {
    constructor(props) {
        super(props);

        this.state = {
            step: 1,
            pageEnd: 4,
            title: [
                `${this.props.t('register.job.pageTitle.contact')}`,
                `${this.props.t('register.job.pageTitle.level')}`,
                `${this.props.t('register.job.pageTitle.exp')}`,
                `${this.props.t('register.job.pageTitle.courses')}`,
            ],
            done: [10, 30, 60, 100],
            left: [90, 70, 40, 0],
            firstName: '',
            firstNameValid: true,
            fatherName: '',
            fatherNameValid: true,
            lastName: '',
            lastNameValid: true,
            mobileNum: '',
            mobileNumValid: true,
            email: '',
            emailValid: true,
            nationality: '',
            nationalityEmpty: false,
            academicDegree: '',
            uniName: '',
            uniNameValid: true,
            speciality: '',
            specialityValid: true,
            experienceOpt: '',
            experienceOptEmpty: false,
            currentlyWorking: '',
            currentlyWorkingEmpty: false,
            currentJob: '',
            currentJobValid: true,
            experieneYears: 0,
            coursesNum: 0,
            coursesTitle: '',
            courses: [],
            file: '',
            englishLevel: 'ضعيف / Poor',
            isValid: true,
            emptyField: false,
            emptyFirst: false,
            emptySecond: false,
            emptyThird: false,
            send: false,
            major: '',
            majorLabel: '',
            otherMajor: '',
            otherInfo: '',
            resumeLink: '',
            resumeEmpty: false,
            error: false,
            maxFileSize: false,
            sendClicked: false,
            optional: false,
        };
    }

    checkNotEmpty = () => {
        const {
            step,
            firstName,
            lastName,
            fatherName,
            mobileNum,
            uniName,
            academicDegree,
            speciality,
            currentJob,
            email,
            nationality,
            major,
            experienceOpt,
            currentlyWorking,
        } = this.state;
        if (step === 1) {
            this.checkNationality();
            if (
                firstName !== '' &&
                fatherName !== '' &&
                lastName !== '' &&
                mobileNum !== '' &&
                email !== '' &&
                nationality !== ''
            ) {
                this.setState({
                    emptyFirst: false,
                    emptyField: false,
                });
                return true;
            } else {
                this.setState({
                    emptyFirst: true,
                });
                return false;
            }
        } else if (step === 2) {
            if (
                uniName !== '' &&
                academicDegree !== '' &&
                speciality !== '' &&
                major !== ''
            ) {
                this.setState({
                    emptySecond: false,
                    emptyField: false,
                });
                return true;
            } else {
                this.setState({
                    emptySecond: true,
                });
                return false;
            }
        } else if (step === 3) {
            this.checkExperience();
            this.checkWorking();
            if (experienceOpt !== '' && currentlyWorking !== '') {
                this.setState({
                    emptyThird: false,
                    emptyField: false,
                });
                return true;
            } else {
                this.setState({
                    emptyThird: true,
                });
                return false;
            }
        } else if (step === 4) {
            return true;
        }
    };

    checkExperience = () => {
        if (this.state.experienceOpt !== '') {
            return true;
        } else
            this.setState({
                experienceOptEmpty: true,
            });
    };

    checkWorking = () => {
        if (this.state.currentlyWorking !== '') {
            return true;
        } else
            this.setState({
                currentlyWorkingEmpty: true,
            });
    };

    checkNationality = () => {
        if (this.state.nationality !== '') {
            return true;
        } else {
            this.setState({
                nationalityEmpty: true,
            });
        }
    };

    validFirst = () => {
        if (name.test(this.state.firstName) === true) {
            this.setState({
                firstNameValid: true,
            });
        } else {
            this.setState({
                firstNameValid: false,
            });
        }
    };

    validFather = () => {
        if (name.test(this.state.fatherName) === true) {
            this.setState({
                fatherNameValid: true,
            });
        } else {
            this.setState({
                fatherNameValid: false,
            });
        }
    };

    validLast = () => {
        if (name.test(this.state.lastName) === true) {
            this.setState({
                lastNameValid: true,
            });
        } else {
            this.setState({
                lastNameValid: false,
            });
        }
    };

    validMobile = () => {
        if (mobile.test(this.state.mobileNum) === true) {
            this.setState({
                mobileNumValid: true,
            });
        } else {
            this.setState({
                mobileNumValid: false,
            });
        }
    };

    validEmail = () => {
        if (emailCheck.test(this.state.email) === true) {
            this.setState({
                emailValid: true,
            });
        } else {
            this.setState({
                emailValid: false,
            });
        }
    };

    validUni = () => {
        if (name.test(this.state.uniName) === true) {
            this.setState({
                uniNameValid: true,
            });
        } else {
            this.setState({
                uniNameValid: false,
            });
        }
    };

    validSpeciality = () => {
        if (name.test(this.state.speciality) === true) {
            this.setState({
                specialityValid: true,
            });
        } else {
            this.setState({
                specialityValid: false,
            });
        }
    };

    validJob = () => {
        if (name.test(this.state.currentJob) === true) {
            this.setState({
                currentJobValid: true,
            });
        } else {
            this.setState({
                currentJobValid: false,
            });
        }
    };

    checkValid = () => {
        const {
            step,
            firstName,
            fatherName,
            lastName,
            mobileNum,
            uniName,
            speciality,
            currentJob,
            email,
        } = this.state;
        if (step === 1) {
            this.validFirst();
            this.validFather();
            this.validLast();
            this.validMobile();
            this.validEmail();
            if (
                name.test(firstName) &&
                name.test(fatherName) &&
                name.test(lastName) &&
                mobile.test(mobileNum) &&
                emailCheck.test(email)
            ) {
                this.setState({
                    isValid: true,
                });
                return true;
            } else {
                return false;
            }
        } else if (step === 2) {
            this.validUni();
            this.validSpeciality();
            if (name.test(uniName) && name.test(speciality)) {
                this.setState({
                    isValid: true,
                });
                return true;
            } else {
                return false;
            }
        } else if (step === 3) {
            this.setState({
                isValid: true,
            });
            return true;
        } else if (step === 4) {
            this.setState({
                isValid: true,
            });
            return true;
        }
    };

    next = () => {
        this.checkNotEmpty();
        this.checkValid();
        if (this.checkValid() === true && this.checkNotEmpty() === true) {
            this.setState({
                step: this.state.step + 1,
            });
        } else if (this.checkNotEmpty() === false) {
            this.setState({
                emptyField: true,
            });
        } else if (
            this.checkNotEmpty() === true &&
            this.checkValid() === false
        ) {
            this.setState({
                isValid: false,
            });
        }
    };

    prev = () => {
        this.setState({
            step: this.state.step - 1,
        });
    };

    send = (e) => {
        e.preventDefault();
        this.checkNotEmpty();
        this.checkValid();
        if (this.checkValid() === true && this.checkNotEmpty() === true) {
            let coursesObj = Object.assign({}, this.state.courses);
            if (this.state.resumeLink === '') {
                this.setState({
                    resumeEmpty: true,
                });
            } else if (this.state.resumeLink.size > 2000000) {
                this.setState({
                    resumeEmpty: false,
                    maxFileSize: true,
                });
            } else {
                this.setState({
                    resumeEmpty: false,
                    maxFileSize: false,
                    sendClicked: true,
                });
                this.fileUpload(coursesObj);
            }
        } else if (this.checkNotEmpty() === false) {
            this.setState({
                emptyField: true,
            });
        } else if (
            this.checkNotEmpty() === true &&
            this.checkValid() === false
        ) {
            this.setState({
                isValid: false,
            });
        }
    };

    option = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
        switch (e.target.name) {
            case 'experienceOpt':
                this.setState({
                    experienceOptEmpty: false,
                });
                break;
            case 'currentlyWorking':
                this.setState({
                    currentlyWorkingEmpty: false,
                });
                break;
            case 'nationality':
                this.setState({
                    nationalityEmpty: false,
                });
                break;
            default:
                console.log('Target not known');
        }
    };

    sendAll = (coursesObj, fileID) => {
        fetch(`${api_url}/autism/items/job_form`, {
            method: 'POST',
            headers: {
                // headers,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                applying_for: this.props.jobTitle,
                first_name: this.state.firstName,
                father_name: this.state.fatherName,
                last_name: this.state.lastName,
                mobile: this.state.mobileNum,
                email: this.state.email,
                nationality: this.state.nationality,
                degree: this.state.academicDegree,
                university: this.state.uniName,
                college: this.state.speciality,
                english_level: this.state.englishLevel,
                past_experience: this.state.experienceOpt,
                exp_years: this.state.experieneYears,
                working: this.state.currentlyWorking,
                job_details: this.state.currentJob,
                courses_amount: this.state.coursesNum,
                courses_titles: coursesObj,
                resume: fileID,
                major: this.state.major,
                other_major: this.state.otherMajor,
                more_info: this.state.otherInfo,
            }),
        })
            .then((res) => res.json())
            .then((res) => {
                if (res.error) {
                    console.log(res);
                    this.setState({
                        error: true,
                        send: false,
                    });
                } else {
                    this.setState({
                        error: false,
                        send: true,
                    });
                    console.log('Success', res);
                }
            });
    };

    handleClick = (e) => {
        e.preventDefault();
        fetch(`${api_url}/autism/files`, {
            method: 'POST',
            headers: {
                // headers,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                data: e.target.value,
            }),
        })
            .then((res) => res.json())
            .then((res) => {
                console.log('Response', res);
            });
    };

    addCourse = (e) => {
        e.preventDefault();
        this.setState({
            courses: [...this.state.courses, this.state.coursesTitle],
            coursesTitle: '',
        });
    };

    deleteCourse = (index) => {
        this.setState({
            courses: this.state.courses.filter((_, i) => {
                return i !== index;
            }),
        });
    };

    onChangeHandler = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            emptyField: false,
        });
    };

    onEnglishLevelChange = (value) => {
        if (value < 5) {
            this.setState({
                englishLevel: 'ضعيف / Poor',
            });
        } else if (value >= 5 && value < 10) {
            this.setState({
                englishLevel: 'جيد / Good',
            });
        } else if (value >= 10 && value < 15) {
            this.setState({
                englishLevel: 'جيد جداً / Very Good',
            });
        } else if (value >= 15) {
            this.setState({
                englishLevel: 'ممتاز / Excellent',
            });
        }
    };

    onExperienceChange = (value) => {
        this.setState({
            experieneYears: value,
        });
    };

    onCoursesNumChange = (value) => {
        this.setState({
            coursesNum: value,
        });
    };

    onCoursesChange = (e) => {
        this.setState({
            coursesTitle: e.target.value,
        });
    };

    sendEnable = (value) => {
        this.setState({
            sendClicked: value,
        });
    };

    onSelect = (e) => {
        switch (e.type) {
            case 'major':
                this.setState({
                    major: e.value,
                    majorLabel: e.label,
                });
                break;
            default:
        }

        this.setState({
            emptyField: false,
        });
    };

    onFile = (e) => {
        this.setState({
            resumeLink: e[0],
        });
    };

    fileUpload = (coursesObj) => {
        const data = new FormData();
        data.append('file', this.state.resumeLink);
        axios.post(`${api_url}/autism/files`, data, headers).then((res) => {
            this.sendAll(coursesObj, res.data.data.id);
        });
    };

    render() {
        const { t } = this.props;
        return (
            <>
                <div
                    className={`form ${
                        i18next.language === 'en' ? 'text-left' : ''
                    }`}
                >
                    <div
                        className='job-desc'
                        dangerouslySetInnerHTML={{
                            __html: this.props.jobDesc,
                        }}
                    ></div>
                    <Form>
                        {this.state.step === 1 ? (
                            <Form.Group controlId='firstStep'>
                                <Form.Row>
                                    <Col
                                        className={`${
                                            i18next.language === 'en'
                                                ? 'ml-0 mr-2em'
                                                : ''
                                        }`}
                                    >
                                        {this.state.firstNameValid === true ? (
                                            <Input
                                                type={'text'}
                                                label={`${t(
                                                    'register.job.formLabels.firstName'
                                                )}`}
                                                name={'firstName'}
                                                value={this.state.firstName}
                                                onChange={this.onChangeHandler}
                                                empty={this.state.emptyField}
                                            />
                                        ) : (
                                            <InvalidInput
                                                type={'text'}
                                                label={`${t(
                                                    'register.job.formLabels.firstName'
                                                )}`}
                                                name={'firstName'}
                                                value={this.state.firstName}
                                                onChange={this.onChangeHandler}
                                                empty={this.state.emptyField}
                                            />
                                        )}
                                    </Col>
                                    <Col
                                        className={`${
                                            i18next.language === 'en'
                                                ? 'ml-0 mr-2em'
                                                : ''
                                        }`}
                                    >
                                        {this.state.fatherNameValid === true ? (
                                            <Input
                                                type={'text'}
                                                label={`${t(
                                                    'register.job.formLabels.fatherName'
                                                )}`}
                                                name={'fatherName'}
                                                value={this.state.fatherName}
                                                onChange={this.onChangeHandler}
                                                empty={this.state.emptyField}
                                            />
                                        ) : (
                                            <InvalidInput
                                                type={'text'}
                                                label={`${t(
                                                    'register.job.formLabels.fatherName'
                                                )}`}
                                                name={'fatherName'}
                                                value={this.state.fatherName}
                                                onChange={this.onChangeHandler}
                                                empty={this.state.emptyField}
                                            />
                                        )}
                                    </Col>
                                </Form.Row>
                                <Form.Row>
                                    <Col
                                        className={`${
                                            i18next.language === 'en'
                                                ? 'ml-0 mr-2em'
                                                : ''
                                        }`}
                                    >
                                        {this.state.lastNameValid === true ? (
                                            <Input
                                                type={'text'}
                                                label={`${t(
                                                    'register.job.formLabels.lastName'
                                                )}`}
                                                name={'lastName'}
                                                value={this.state.lastName}
                                                onChange={this.onChangeHandler}
                                                empty={this.state.emptyField}
                                            />
                                        ) : (
                                            <InvalidInput
                                                type={'text'}
                                                label={`${t(
                                                    'register.job.formLabels.lastName'
                                                )}`}
                                                name={'lastName'}
                                                value={this.state.lastName}
                                                onChange={this.onChangeHandler}
                                                empty={this.state.emptyField}
                                            />
                                        )}
                                    </Col>
                                    <Col
                                        className={`${
                                            i18next.language === 'en'
                                                ? 'ml-0 mr-2em'
                                                : ''
                                        }`}
                                    >
                                        {this.state.mobileNumValid === true ? (
                                            <Input
                                                type={'text'}
                                                label={`${t(
                                                    'register.job.formLabels.mobileNum'
                                                )}`}
                                                name={'mobileNum'}
                                                value={this.state.mobileNum}
                                                onChange={this.onChangeHandler}
                                                empty={this.state.emptyField}
                                            />
                                        ) : (
                                            <InvalidInput
                                                type={'text'}
                                                label={`${t(
                                                    'register.job.formLabels.mobileNum'
                                                )}`}
                                                name={'mobileNum'}
                                                value={this.state.mobileNum}
                                                onChange={this.onChangeHandler}
                                                empty={this.state.emptyField}
                                            />
                                        )}
                                    </Col>
                                </Form.Row>
                                <Form.Row>
                                    <Col
                                        className={`${
                                            i18next.language === 'en'
                                                ? 'ml-0 mr-2em'
                                                : ''
                                        }`}
                                    >
                                        <Form.Label
                                            style={{
                                                color: `${
                                                    this.state
                                                        .nationalityEmpty ===
                                                    true
                                                        ? 'red'
                                                        : ''
                                                }`,
                                            }}
                                        >
                                            {`${t(
                                                'register.job.formLabels.nationality'
                                            )}`}
                                        </Form.Label>
                                        <div
                                            key={`inline-radio`}
                                            className='mb-3'
                                        >
                                            <Form.Check
                                                label={`${t(
                                                    'register.child.formLabels.nationalityOptions.saudi'
                                                )}`}
                                                type='radio'
                                                id={`inline-radio-1`}
                                                value='saudi'
                                                name='nationality'
                                                checked={
                                                    this.state.nationality ===
                                                    'saudi'
                                                }
                                                onChange={this.option}
                                                // className='check'
                                            />
                                            <Form.Check
                                                label={`${t(
                                                    'register.child.formLabels.nationalityOptions.nonSaudi'
                                                )}`}
                                                type='radio'
                                                id={`inline-radio-2`}
                                                value='nonSaudi'
                                                name='nationality'
                                                checked={
                                                    this.state.nationality ===
                                                    'nonSaudi'
                                                }
                                                onChange={this.option}
                                                // className='check'
                                            />
                                        </div>
                                    </Col>
                                    <Col
                                        className={`${
                                            i18next.language === 'en'
                                                ? 'ml-0 mr-2em'
                                                : ''
                                        }`}
                                    >
                                        {this.state.emailValid === true ? (
                                            <Input
                                                type={'text'}
                                                label={`${t(
                                                    'register.job.formLabels.email'
                                                )}`}
                                                name={'email'}
                                                value={this.state.email}
                                                onChange={this.onChangeHandler}
                                                empty={this.state.emptyField}
                                            />
                                        ) : (
                                            <InvalidInput
                                                type={'text'}
                                                label={`${t(
                                                    'register.job.formLabels.email'
                                                )}`}
                                                name={'email'}
                                                value={this.state.email}
                                                onChange={this.onChangeHandler}
                                                empty={this.state.emptyField}
                                            />
                                        )}
                                    </Col>
                                </Form.Row>
                                {this.state.emptyFirst === true ? (
                                    <p className='empty-msg'>
                                        {`${t('empty')}`}
                                    </p>
                                ) : (
                                    <></>
                                )}
                                {this.state.isValid === false ? (
                                    <p className='empty-msg'>
                                        {`${t('invalid')}`}
                                    </p>
                                ) : (
                                    <></>
                                )}
                            </Form.Group>
                        ) : (
                            <>
                                {this.state.step === 2 ? (
                                    <Form.Group controlId='firstStep'>
                                        <Form.Row>
                                            <Col
                                                className={`${
                                                    i18next.language === 'en'
                                                        ? 'ml-0 mr-2em'
                                                        : ''
                                                }`}
                                            >
                                                <Input
                                                    type={'text'}
                                                    label={`${t(
                                                        'register.job.formLabels.academicDegree'
                                                    )}`}
                                                    name={'academicDegree'}
                                                    value={
                                                        this.state
                                                            .academicDegree
                                                    }
                                                    onChange={
                                                        this.onChangeHandler
                                                    }
                                                    empty={
                                                        this.state.emptyField
                                                    }
                                                />
                                            </Col>
                                            <Col
                                                className={`${
                                                    i18next.language === 'en'
                                                        ? 'ml-0 mr-2em'
                                                        : ''
                                                }`}
                                            >
                                                {this.state.uniNameValid ===
                                                true ? (
                                                    <Input
                                                        type={'text'}
                                                        label={`${t(
                                                            'register.job.formLabels.uniName'
                                                        )}`}
                                                        name={'uniName'}
                                                        value={
                                                            this.state.uniName
                                                        }
                                                        onChange={
                                                            this.onChangeHandler
                                                        }
                                                        empty={
                                                            this.state
                                                                .emptyField
                                                        }
                                                    />
                                                ) : (
                                                    <InvalidInput
                                                        type={'text'}
                                                        label={`${t(
                                                            'register.job.formLabels.uniName'
                                                        )}`}
                                                        name={'uniName'}
                                                        value={
                                                            this.state.uniName
                                                        }
                                                        onChange={
                                                            this.onChangeHandler
                                                        }
                                                        empty={
                                                            this.state
                                                                .emptyField
                                                        }
                                                    />
                                                )}
                                            </Col>
                                        </Form.Row>
                                        <Form.Row>
                                            <Col
                                                className={`${
                                                    i18next.language === 'en'
                                                        ? 'ml-0 mr-2em'
                                                        : ''
                                                }`}
                                            >
                                                {this.state.specialityValid ===
                                                true ? (
                                                    <Input
                                                        type={'text'}
                                                        label={`${t(
                                                            'register.job.formLabels.speciality'
                                                        )}`}
                                                        name={'speciality'}
                                                        value={
                                                            this.state
                                                                .speciality
                                                        }
                                                        onChange={
                                                            this.onChangeHandler
                                                        }
                                                        empty={
                                                            this.state
                                                                .emptyField
                                                        }
                                                    />
                                                ) : (
                                                    <InvalidInput
                                                        type={'text'}
                                                        label={`${t(
                                                            'register.job.formLabels.speciality'
                                                        )}`}
                                                        name={'speciality'}
                                                        value={
                                                            this.state
                                                                .speciality
                                                        }
                                                        onChange={
                                                            this.onChangeHandler
                                                        }
                                                        empty={
                                                            this.state
                                                                .emptyField
                                                        }
                                                    />
                                                )}
                                            </Col>
                                            <Col
                                                className={`${
                                                    i18next.language === 'en'
                                                        ? 'ml-0 mr-2em'
                                                        : ''
                                                }`}
                                            >
                                                <Form.Label>
                                                    {`${t(
                                                        'register.job.formLabels.englishLevel'
                                                    )}`}
                                                </Form.Label>
                                                <Slider
                                                    allowCross={false}
                                                    defaultValue={[0, 5]}
                                                    step={5}
                                                    max={15}
                                                    onChange={
                                                        this
                                                            .onEnglishLevelChange
                                                    }
                                                    reverse
                                                />
                                                <Form.Label>
                                                    {this.state.englishLevel}
                                                </Form.Label>
                                            </Col>
                                        </Form.Row>
                                        <Form.Row>
                                            {i18next.language === 'ar' ? (
                                                <Col
                                                    className={`${
                                                        i18next.language ===
                                                        'en'
                                                            ? 'ml-0 mr-2em'
                                                            : ''
                                                    }`}
                                                >
                                                    <Select
                                                        options={majorOptns}
                                                        onChange={this.onSelect}
                                                        styles={
                                                            this.state
                                                                .emptyField ===
                                                            true
                                                                ? dangerStyles
                                                                : colourStyles
                                                        }
                                                        className='react-select-container'
                                                        classNamePrefix='react-select'
                                                        placeholder={`${
                                                            this.state
                                                                .majorLabel ===
                                                            ''
                                                                ? `${t(
                                                                      'register.job.formLabels.major'
                                                                  )}`
                                                                : `${this.state.majorLabel}`
                                                        }`}
                                                    />
                                                </Col>
                                            ) : (
                                                <Col
                                                    className={`${
                                                        i18next.language ===
                                                        'en'
                                                            ? 'ml-0 mr-2em'
                                                            : ''
                                                    }`}
                                                >
                                                    <Select
                                                        options={en_majorOptns}
                                                        onChange={this.onSelect}
                                                        styles={
                                                            this.state
                                                                .emptyField ===
                                                            true
                                                                ? dangerStyles
                                                                : colourStyles
                                                        }
                                                        className='react-select-container'
                                                        classNamePrefix='react-select'
                                                        placeholder={`${
                                                            this.state
                                                                .majorLabel ===
                                                            ''
                                                                ? `${t(
                                                                      'register.job.formLabels.major'
                                                                  )}`
                                                                : `${this.state.majorLabel}`
                                                        }`}
                                                    />
                                                </Col>
                                            )}
                                            <Col
                                                className={`${
                                                    i18next.language === 'en'
                                                        ? 'ml-0 mr-2em'
                                                        : ''
                                                }`}
                                            >
                                                <Input
                                                    type={'text'}
                                                    label={`${t(
                                                        'register.job.formLabels.otherSpeciality'
                                                    )}`}
                                                    name={'otherMajor'}
                                                    value={
                                                        this.state.otherMajor
                                                    }
                                                    onChange={
                                                        this.onChangeHandler
                                                    }
                                                />
                                            </Col>
                                        </Form.Row>
                                        {this.state.emptySecond === true ? (
                                            <p className='empty-msg'>
                                                {`${t('empty')}`}
                                            </p>
                                        ) : (
                                            <></>
                                        )}
                                        {this.state.isValid === false ? (
                                            <p className='empty-msg'>
                                                {`${t('invalid')}`}
                                            </p>
                                        ) : (
                                            <></>
                                        )}
                                    </Form.Group>
                                ) : (
                                    <>
                                        {this.state.step === 3 ? (
                                            <Form.Group controlId='firstStep'>
                                                <Form.Row>
                                                    <Col
                                                        className={`${
                                                            i18next.language ===
                                                            'en'
                                                                ? 'ml-0 mr-2em'
                                                                : ''
                                                        }`}
                                                    >
                                                        <Form.Label
                                                            style={{
                                                                color: `${
                                                                    this.state
                                                                        .experienceOptEmpty ===
                                                                    true
                                                                        ? 'red'
                                                                        : ''
                                                                }`,
                                                            }}
                                                        >
                                                            {`${t(
                                                                'register.job.formLabels.experience'
                                                            )}`}
                                                        </Form.Label>
                                                        <div
                                                            key={`inline-radio`}
                                                            className='mb-3'
                                                        >
                                                            <Form.Check
                                                                label={`${t(
                                                                    'yes'
                                                                )}`}
                                                                type='radio'
                                                                id={`inline-radio-1`}
                                                                value='yes'
                                                                name='experienceOpt'
                                                                checked={
                                                                    this.state
                                                                        .experienceOpt ===
                                                                    'yes'
                                                                }
                                                                onChange={
                                                                    this.option
                                                                }
                                                                // className='check'
                                                            />
                                                            <Form.Check
                                                                label={`${t(
                                                                    'no'
                                                                )}`}
                                                                type='radio'
                                                                id={`inline-radio-2`}
                                                                value='no'
                                                                name='experienceOpt'
                                                                checked={
                                                                    this.state
                                                                        .experienceOpt ===
                                                                    'no'
                                                                }
                                                                onChange={
                                                                    this.option
                                                                }
                                                                // className='check'
                                                            />
                                                        </div>
                                                    </Col>
                                                    <Col
                                                        className={`${
                                                            i18next.language ===
                                                            'en'
                                                                ? 'ml-0 mr-2em'
                                                                : ''
                                                        }`}
                                                    >
                                                        <Form.Label
                                                            style={{
                                                                color: `${
                                                                    this.state
                                                                        .currentlyWorkingEmpty ===
                                                                    true
                                                                        ? 'red'
                                                                        : ''
                                                                }`,
                                                            }}
                                                        >
                                                            {`${t(
                                                                'register.job.formLabels.currentlyWorking'
                                                            )}`}
                                                        </Form.Label>
                                                        <div
                                                            key={`inline-radio`}
                                                            className='mb-3'
                                                        >
                                                            <Form.Check
                                                                label={`${t(
                                                                    'yes'
                                                                )}`}
                                                                type='radio'
                                                                id={`inline-radio-1`}
                                                                value='yes'
                                                                name='currentlyWorking'
                                                                checked={
                                                                    this.state
                                                                        .currentlyWorking ===
                                                                    'yes'
                                                                }
                                                                onChange={
                                                                    this.option
                                                                }
                                                                // className='check'
                                                            />
                                                            <Form.Check
                                                                label={`${t(
                                                                    'no'
                                                                )}`}
                                                                type='radio'
                                                                id={`inline-radio-2`}
                                                                value='no'
                                                                name='currentlyWorking'
                                                                checked={
                                                                    this.state
                                                                        .currentlyWorking ===
                                                                    'no'
                                                                }
                                                                onChange={
                                                                    this.option
                                                                }
                                                                // className='check'
                                                            />
                                                        </div>
                                                    </Col>
                                                </Form.Row>
                                                <Form.Row>
                                                    <Col
                                                        className={`${
                                                            i18next.language ===
                                                            'en'
                                                                ? 'ml-0 mr-2em'
                                                                : ''
                                                        }`}
                                                    >
                                                        <Form.Label>
                                                            {`${t(
                                                                'register.job.formLabels.experienceYears'
                                                            )}`}
                                                        </Form.Label>
                                                        <Slider
                                                            allowCross={false}
                                                            defaultValue={[
                                                                0,
                                                                0,
                                                            ]}
                                                            step={1}
                                                            max={10}
                                                            onChange={
                                                                this
                                                                    .onExperienceChange
                                                            }
                                                            reverse
                                                        />
                                                        <Form.Label>
                                                            {this.state
                                                                .experieneYears ===
                                                            10
                                                                ? `${this.state.experieneYears}+`
                                                                : this.state
                                                                      .experieneYears}
                                                        </Form.Label>
                                                    </Col>
                                                    <Col
                                                        className={`${
                                                            i18next.language ===
                                                            'en'
                                                                ? 'ml-0 mr-2em'
                                                                : ''
                                                        }`}
                                                    >
                                                        {this.state
                                                            .currentJobValid ===
                                                        true ? (
                                                            <Input
                                                                type={'text'}
                                                                label={`${t(
                                                                    'register.job.formLabels.currentJob'
                                                                )}`}
                                                                name={
                                                                    'currentJob'
                                                                }
                                                                value={
                                                                    this.state
                                                                        .currentJob
                                                                }
                                                                onChange={
                                                                    this
                                                                        .onChangeHandler
                                                                }
                                                                empty={
                                                                    this.state
                                                                        .optional
                                                                }
                                                            />
                                                        ) : (
                                                            <InvalidInput
                                                                type={'text'}
                                                                label={`${t(
                                                                    'register.job.formLabels.currentJob'
                                                                )}`}
                                                                name={
                                                                    'currentJob'
                                                                }
                                                                value={
                                                                    this.state
                                                                        .currentJob
                                                                }
                                                                onChange={
                                                                    this
                                                                        .onChangeHandler
                                                                }
                                                                empty={
                                                                    this.state
                                                                        .optional
                                                                }
                                                            />
                                                        )}
                                                    </Col>
                                                </Form.Row>
                                                {this.state.emptyThird ===
                                                true ? (
                                                    <p className='empty-msg'>
                                                        {`${t('empty')}`}
                                                    </p>
                                                ) : (
                                                    <></>
                                                )}
                                                {this.state.isValid ===
                                                false ? (
                                                    <p className='empty-msg'>
                                                        {`${t('invalid')}`}
                                                    </p>
                                                ) : (
                                                    <></>
                                                )}
                                            </Form.Group>
                                        ) : (
                                            <Form.Group controlId='firstStep'>
                                                <Form.Row>
                                                    <Col
                                                        className={`${
                                                            i18next.language ===
                                                            'en'
                                                                ? 'ml-0 mr-2em'
                                                                : ''
                                                        }`}
                                                    >
                                                        <Form.Row>
                                                            <Col
                                                                className={`${
                                                                    i18next.language ===
                                                                    'en'
                                                                        ? 'ml-0 mr-2em'
                                                                        : ''
                                                                }`}
                                                            >
                                                                <Form.Label>
                                                                    {`${t(
                                                                        'register.job.formLabels.coursesNum'
                                                                    )}`}
                                                                </Form.Label>
                                                                <Slider
                                                                    allowCross={
                                                                        false
                                                                    }
                                                                    defaultValue={[
                                                                        0,
                                                                        0,
                                                                    ]}
                                                                    step={1}
                                                                    max={30}
                                                                    onChange={
                                                                        this
                                                                            .onCoursesNumChange
                                                                    }
                                                                    reverse
                                                                />
                                                                <Form.Label>
                                                                    {this.state
                                                                        .coursesNum ===
                                                                    30
                                                                        ? `${this.state.coursesNum}+`
                                                                        : this
                                                                              .state
                                                                              .coursesNum}
                                                                </Form.Label>
                                                            </Col>
                                                        </Form.Row>
                                                        <Form.Row>
                                                            <Col className='courses'>
                                                                <Input
                                                                    type={
                                                                        'text'
                                                                    }
                                                                    label={`${t(
                                                                        'register.job.formLabels.coursesTitle'
                                                                    )}`}
                                                                    name={
                                                                        'coursesTitle'
                                                                    }
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .coursesTitle
                                                                    }
                                                                    onChange={
                                                                        this
                                                                            .onCoursesChange
                                                                    }
                                                                    empty={
                                                                        this
                                                                            .state
                                                                            .emptyField
                                                                    }
                                                                />

                                                                <button
                                                                    onClick={(
                                                                        e
                                                                    ) => {
                                                                        this.addCourse(
                                                                            e
                                                                        );
                                                                    }}
                                                                    className={`${
                                                                        this
                                                                            .state
                                                                            .coursesTitle ===
                                                                        ''
                                                                            ? 'disabled'
                                                                            : ''
                                                                    }`}
                                                                >
                                                                    {`${t(
                                                                        'register.job.formLabels.add'
                                                                    )}`}
                                                                </button>
                                                            </Col>
                                                        </Form.Row>
                                                        {this.state.courses.map(
                                                            (course, index) => {
                                                                return (
                                                                    <Form.Row
                                                                        key={
                                                                            index
                                                                        }
                                                                        style={{
                                                                            marginBottom:
                                                                                '0.5em',
                                                                        }}
                                                                    >
                                                                        <Col
                                                                            className={`${
                                                                                i18next.language ===
                                                                                'en'
                                                                                    ? 'ml-0 mr-2em'
                                                                                    : ''
                                                                            }`}
                                                                        >
                                                                            <div className='course'>
                                                                                <h5>
                                                                                    {
                                                                                        course
                                                                                    }
                                                                                </h5>
                                                                                <h4
                                                                                    onClick={() =>
                                                                                        this.deleteCourse(
                                                                                            index
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    X
                                                                                </h4>
                                                                            </div>
                                                                        </Col>
                                                                    </Form.Row>
                                                                );
                                                            }
                                                        )}
                                                    </Col>
                                                    <Col
                                                        className={`divider ${
                                                            i18next.language ===
                                                            'en'
                                                                ? 'ml-0 mr-2em'
                                                                : ''
                                                        }`}
                                                    >
                                                        <hr />
                                                    </Col>
                                                    <Col
                                                        className={` resume ${
                                                            i18next.language ===
                                                            'en'
                                                                ? 'ml-0 mr-2em'
                                                                : ''
                                                        }`}
                                                    >
                                                        <Form.Row className='resume-row'>
                                                            <Col
                                                                className={`${
                                                                    i18next.language ===
                                                                    'en'
                                                                        ? 'ml-0 mr-2em'
                                                                        : ''
                                                                }`}
                                                            >
                                                                <Col
                                                                    className={`dnd-container ${
                                                                        i18next.language ===
                                                                        'en'
                                                                            ? 'ml-0 mr-2em'
                                                                            : ''
                                                                    }`}
                                                                >
                                                                    <Previews
                                                                        onFile={
                                                                            this
                                                                                .onFile
                                                                        }
                                                                    />
                                                                </Col>
                                                            </Col>
                                                        </Form.Row>
                                                        <Form.Row>
                                                            <Col
                                                                className={`${
                                                                    i18next.language ===
                                                                    'en'
                                                                        ? 'ml-0 mr-2em'
                                                                        : ''
                                                                }`}
                                                            >
                                                                <Input
                                                                    type={
                                                                        'text'
                                                                    }
                                                                    label={`${t(
                                                                        'register.job.formLabels.otherInfo'
                                                                    )}`}
                                                                    name={
                                                                        'otherInfo'
                                                                    }
                                                                    value={
                                                                        this
                                                                            .state
                                                                            .otherInfo
                                                                    }
                                                                    onChange={
                                                                        this
                                                                            .onChangeHandler
                                                                    }
                                                                    empty={
                                                                        this
                                                                            .state
                                                                            .emptyField
                                                                    }
                                                                />
                                                            </Col>
                                                        </Form.Row>
                                                    </Col>
                                                </Form.Row>
                                                {this.state.emptyFourth ===
                                                true ? (
                                                    <p className='empty-msg'>
                                                        {`${t('empty')}`}
                                                    </p>
                                                ) : (
                                                    <></>
                                                )}
                                                {this.state.isValid ===
                                                false ? (
                                                    <p className='empty-msg'>
                                                        {`${t('invalid')}`}
                                                    </p>
                                                ) : (
                                                    <></>
                                                )}
                                                {this.state.resumeEmpty ===
                                                true ? (
                                                    <p className='empty-msg'>
                                                        {`${t('emptyResume')}`}
                                                    </p>
                                                ) : (
                                                    <></>
                                                )}
                                                {this.state.maxFileSize ===
                                                true ? (
                                                    <p className='empty-msg'>
                                                        {`${t('maxFileSize')}`}
                                                    </p>
                                                ) : (
                                                    <></>
                                                )}
                                            </Form.Group>
                                        )}
                                    </>
                                )}
                            </>
                        )}
                    </Form>
                </div>
                <Stepper
                    title={this.state.title}
                    step={this.state.step}
                    pageEnd={this.state.pageEnd}
                    done={this.state.done}
                    left={this.state.left}
                    next={this.next}
                    prev={this.prev}
                    send={this.send}
                    canSend={this.state.send}
                    error={this.state.error}
                    clicked={this.state.sendClicked}
                    sendEnable={this.sendEnable}
                />
            </>
        );
    }
}

export default withTranslation()(Job);
